import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, MapPin, Instagram } from 'lucide-react';
import './Footer.css';

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-section">
          <h3 className="footer-title">FesteDaPiccoli</h3>
          <p className="footer-description">
            La piattaforma più completa per trovare location e intrattenimento per le feste di compleanno dei tuoi bambini in Italia.
          </p>
        </div>

        <div className="footer-section">
          <h4 className="footer-heading">Link Utili</h4>
          <ul className="footer-links">
            <li>
              <Link to="/cerca?tipo=location">Cerca Location</Link>
            </li>
            <li>
              <Link to="/cerca?tipo=animazione">Cerca Intrattenimento</Link>
            </li>
            <li>
              <Link to="/registrazione">Diventa fornitore</Link>
            </li>
            <li>
              <Link to="/guida">Guida per i fornitori</Link>
            </li>
            <li>
              <Link to="/">Home</Link>
            </li>
            <li>
              <Link to="/privacy">Privacy Policy</Link>
            </li>
          </ul>
        </div>

        <div className="footer-section">
          <h4 className="footer-heading">Contatti</h4>
          <div className="contact-item">
            <Mail size={16} />
            <a href="mailto:milanodapiccoli@gmail.com">milanodapiccoli@gmail.com</a>
          </div>
          <div className="contact-item">
            <MapPin size={16} />
            <span>Milano, Italia</span>
          </div>
          <div className="contact-item">
            <Instagram size={16} />
            <a href="https://www.instagram.com/festedapiccoli/" target="_blank" rel="noreferrer">@festedapiccoli</a>
          </div>
        </div>

        <div className="footer-section">
          <h4 className="footer-heading">Comunità</h4>
          <p className="footer-brand">
            Parte della famiglia{' '}
            <a href="https://www.milanodapiccoli.it/" target="_blank" rel="noreferrer"><strong>MilanoDaPiccoli</strong></a>
          </p>
          <p className="footer-tagline">
            Vi aiutiamo a creare ricordi indimenticabili per i bambini
          </p>
        </div>
      </div>

      <div className="footer-bottom">
        <p>&copy; {new Date().getFullYear()} FesteDaPiccoli. Tutti i diritti riservati.</p>
      </div>
    </footer>
  );
}

export default Footer;
